<template>
  <div>
    <b-row>
      <b-col>
        <Title captionTab="Итоговый отчет по расходам" id="title" class="my-1"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card class="mb-1 p-1" no-body bg-variant="secondary">
          <b-row>
            <b-col md="5">
              <b-input-group prepend="Период" size="sm">
                <b-form-input type="date" v-model="dat1" placeholder="от" @change="checkDate1"></b-form-input>
                <b-form-input type="date" v-model="dat2" placeholder="до" @change="checkDate2"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col md="3">
              <b-input-group prepend="Вид ЕКП" size="sm">
                <b-form-select v-model="ekptypeId" :options="ekpTypeList">
                </b-form-select>
              </b-input-group>
            </b-col>
            <b-col sm="4">
              <b-button variant="warning" size="sm" class="mx-1" @click="loadNorm">Сформировать</b-button>
              <b-button variant="primary" size="sm" class="mx-1" @click="exportExcel">В Excel</b-button>
              <!--<a v-bind:download="dfileName" v-if="downloadFile !== ''" v-bind:href="downloadFile" class="btn btn-success">Скачать</a>-->
              <b-button size="sm" v-if="downloadFileLink !== ''" variant="success" @click="downloadFile()">
                <b-icon icon="download"/>
                Скачать файл
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div id="normTable">
          <b-table-simple hover dark responsive
                          sticky-header="75vh"
                          bordered :columns="columns"
                          ref="normTable">
            <b-thead head-variant="dark">
              <b-tr>
                <b-th variant="primary">
                  КОСГУ
                </b-th>
                <b-th variant="primary">
                  Всего
                </b-th>
                <b-th v-for="(col,index) in columns" :key="index" :variant="col.variant">
                  {{ col.label }}
                </b-th>
              </b-tr>
            </b-thead>
            <b-tbody v-for="(item,index) in items" :key="index">
              <b-tr>
                <b-td :rowspan="item.facts.length+1" variant="primary">{{ item.code }}</b-td>
                <b-td :rowspan="item.facts.length+1" variant="primary">{{ item.summAll }}</b-td>
              </b-tr>
              <b-tr v-for="(row, itemIndex) in item.facts" :key="itemIndex+'_tr'">
                <b-td v-for="(col,index2) in columns" :key="index2 + '_td'" :variant="col.variant">
                  {{ getCellValue(row, col.key) }}
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
      </b-col>
    </b-row>

    <b-modal id="modal-load" centered title="Загрузка данных" v-model="modalLoadOpened"
             hide-header-close no-close-on-backdrop no-close-on-esc hide-footer>
      <p class="text-center">
        <b-spinner></b-spinner>
      </p>
    </b-modal>

  </div>

</template>

<script>
import http from '@/http-common'
import Title from "@/components/TitlePage.vue";

export default {
  name: 'NormPage',
  components: {Title},
  data() {
    return {
      items: [],
      columns: [
        {key: 'nameCost', label: 'Наименование расхода', sortable: true, variant: 'primary', tdClass: 'normaClass300'},
      ],
      filter: null,
      filter2: null,
      selectMode: 'single',
      selected: [],
      eventkindList: [],
      editItem: {event_normList: []},
      modalEditOpened: false,
      costs: [],
      events: [],
      aCodes: [],
      analyticCode: 0,
      dat1: null,
      dat2: null,
      downloadFileLink: '',
      dfileName: '',
      modalLoadOpened: false,
      ekpTypeList: [],
      ekptypeId: null
    }
  },
  created() {
    this.dat1 = new Date().getFullYear().toString() + "-01-01";
    this.dat2 = new Date().getFullYear().toString() + "-12-31";
    this.loadEventKind();
    this.loadEkpTypes();
  },
  methods: {
    loadEkpTypes() {
      var vm = this;
      var ekptyp = {}
      ekptyp.value = null
      ekptyp.text = 'Все'
      vm.ekpTypeList = [ekptyp]
      http.get('/workkind/EKP_TYPE/list')
      .then((response) => {
        response.data.forEach(function (x) {
          x.value = x.id;
          x.text = x.name;
          vm.ekpTypeList.push(x)
        })
      })
      .catch((error) => console.log(error.message));
    },
    getCellValue(row, key) {
      if (key.indexOf('.') > 0) {
        var m = key.split('.');
        return row[m[0]][m[1]];
      } else {
        return row[key];
      }
    },
    exportExcel() {
      this.downloadFileLink = '';
      if (this.items && this.items.length > 0) {
        http.post('/report/cost/excel', this.items)
        .then((response) => {
          if (response.data.ok || response.data.name !== '') {
            this.downloadFileLink = '/report/download?name=' + encodeURIComponent(response.data.name);
            this.dfileName = 'Итоговый отчёт по разделам.xls';
          } else {
            alert("Отчет не сформирован!");
          }
        })
        .catch((error) => console.log(error.response.data));
      } else {
        alert("Отчет пустой!");
      }
    },
    validate_date(value) {
      let arrD = value.split("-"); // yyyy-mm-dd
      arrD[1] -= 1;
      let sTmp = arrD[0] + '-' + arrD[1] + '-' + arrD[2];
      return new Date(sTmp) !== 'Invalid Date';
    },
    checkDate1() {
      if (this.validate_date(this.dat1) && this.dat1 > this.dat2) {
        this.dat2 = this.dat1
      }
    },
    checkDate2() {
      if (this.validate_date(this.dat2) && this.dat1 > this.dat2) {
        this.dat1 = this.dat2
      }
    },
    loadEventKind() {
      var vm = this;
      http.get('/eventkind/list')
      .then((response) => {
        vm.eventkindList = response.data;
        var col = {
          key: 'summ',
          label: 'Итого',
          variant: 'info'
        }
        vm.columns.push(col);
        vm.eventkindList.forEach(function (x) {
          var col = {
            key: 'event.event_' + x.id,
            label: x.nameKind,
            tdClass: 'normaClass'
          }
          vm.columns.push(col);
        })
      })
      .catch((error) => console.log(error.message));
    },
    loadNorm() {
      var vm = this;
      var filter = '';
      if (this.ekptypeId && this.ekptypeId > 0) {
        filter += '&ekptypeId=' + this.ekptypeId;
      }
      if (this.dat1) {
        filter += '&dat1=' + this.dat1;
      }
      if (this.dat2) {
        filter += '&dat2=' + this.dat2;
      }
      this.modalLoadOpened = true;
      http.get('/norm/table/fact?' + filter)
      .then((response) => {
        vm.items = response.data;
        vm.items.forEach(function (item) {
          var sumAll = 0;
          item.facts.forEach(function (fact) {
            fact._showDetails = false;
            var summ = 0;
            fact.event = {};
            fact.event_normList.forEach(function (ev) {
              fact.event['event_' + ev.eventKindId] = ev.summ.toFixed(2) + ' руб';
              summ += ev.summ;
            });
            if (summ > 0) {
              fact.summ = summ.toFixed(2) + ' руб';
              sumAll += summ;
            }
          })
          item.summAll = sumAll > 0 ? sumAll.toFixed(2) + ' руб' : '';
        })
      })
      .catch((error) => console.log(error.message))
      .finally(() => this.modalLoadOpened = false);
    },
    loadCosts() {
      var vm = this;
      http.get('/cost/list')
      .then((response) => {
        vm.costs = response.data;
        vm.costs.forEach(function (x) {
          x.value = x.id;
          x.text = x.nameCost;
        })
      })
      .catch((error) => console.log(error.message));
    },
    loadCodes() {
      var vm = this;
      http.get('/cost/analytic/list')
      .then((response) => {
        vm.aCodes = response.data;
        vm.aCodes.forEach(function (x) {
          x.value = x.id;
          x.text = x.code + '-' + x.statiya;
        })
        if (vm.aCodes.length > 0) {
          vm.analyticCode = vm.aCodes[0].id;
          this.loadNorm()
        }
      })
      .catch((error) => console.log(error.message));
    },
    loadEvents(rec) {
      var vm = this;
      http.get('/eventkind/list')
      .then((response) => {
        vm.events = response.data;
        vm.events.forEach(function (x) {
          rec.event_normList.forEach(function (item) {
            if (item.eventKindId === x.id) {
              x.norm_id = item.id;
              x.norma = item.norma;
              x.comment = item.comment;
            }
          })
        })
      })
      .catch((error) => console.log(error.message));
    },
    showDetails(rec) {
      if (rec.childs.length > 0) {
        rec._showDetails = !rec._showDetails;
      }
    },
    downloadFile() {
      var vm = this;
      this.modalLoadOpened = true;
      http.get(this.downloadFileLink,
          {
            responseType: 'arraybuffer',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/pdf'
            }
          }
      ).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', vm.dfileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      }).finally(() => vm.modalLoadOpened = false);
    }
  }
}
</script>
<style>
.normaClass {
  max-width: 50px;
  mim-width: 50px;
}

.normaClass80 {
  max-width: 80px;
  mim-width: 80px;
}

.normaClass300 {
  max-width: 300px;
  mim-width: 300px;
}
</style>
